import { Pipe, PipeTransform } from '@angular/core';

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1000 |  speedTransfer}}
 *   formats to: 1 kbps
 */
@Pipe({ name: 'speedTransfer' })
export class SpeedTransferPipe implements PipeTransform {
  private units = ['bps', 'kbps', 'mbps', 'gbps', 'tbps'];

  public transform(bytes: number = 0, precision: number = 2): string {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) { return '?'; }

    let unit = 0;

    while (bytes >= 1000) {
      bytes /= 1000;
      unit++;
    }

    return bytes.toFixed(+precision) + ' ' + this.units[unit];
  }
}
